import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { OAUTH_PROVIDERS, OAuthProvider } from '@/constants/auth-providers';

interface OAuthButtonProps {
  provider: OAuthProvider;
  loading?: boolean;
  disabled?: boolean;
  showLastUsed?: boolean;
  onClick: (provider: OAuthProvider) => void;
}

export const OAuthButton = ({
  provider,
  loading = false,
  disabled = false,
  showLastUsed = false,
  onClick,
}: OAuthButtonProps) => {
  // derived values
  const { label, Icon } = OAUTH_PROVIDERS[provider];

  // event handlers
  const handleClick = () => onClick(provider);

  return (
    <Button
      type="button"
      variant="outline"
      className="relative w-full"
      disabled={disabled || loading}
      onClick={handleClick}
    >
      {loading ? (
        <Loader2 className="size-4 animate-spin" />
      ) : (
        <>
          <Icon className="size-4" />
          {label}
          {showLastUsed && (
            <span className="absolute right-3 rounded bg-brand-50 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-brand-700">
              Last used
            </span>
          )}
        </>
      )}
    </Button>
  );
};
